<template>
    <LaBaseTable data-test="alert-log-table" :headers="headers" :items="data" stripped>
        <template #no-data>No alerts.</template>

        <template #item-created_at="{ item }">
            <span>{{ formatDateTimePragueTimeZone(item.created_at) }}</span>
        </template>

        <template #item-status="{ item }">
            <div>
                <LaStatusLabel :type="statusLabelType(item.status)" :label="item.status" />
                <div v-if="item.attempts" class="muted">{{ item.attempts }} failed attempt(s)</div>
            </div>
        </template>

        <template #item-data="{ item }">
            <div class="data">
                <div v-for="(value, key) in item.data" :key="key">
                    <span class="data-key">{{ key }}</span> {{ value }}
                </div>
            </div>
        </template>

        <template #item-sent_at="{ item }">
            <span>{{ item.sent_at ? formatDateTimePragueTimeZone(item.sent_at) : "—" }}</span>
        </template>
    </LaBaseTable>
</template>

<script>
import LaBaseTable from "@/components/BaseTable";
import LaStatusLabel from "@/components/StatusLabel";
import { formatDateTimePragueTimeZone } from "@/helpers/filters.js";
import { statusLabelType } from "@/components/alerts/helpers";

export default {
    name: "LaAlertLogTable",
    components: {
        LaBaseTable,
        LaStatusLabel,
    },
    props: {
        data: {
            required: true,
        },
    },
    computed: {
        headers() {
            return [
                { text: "created", value: "created_at", direction: -1 },
                { text: "type", value: "code" },
                { text: "status", value: "status" },
                { text: "data", value: "data", flex: "3", sortable: false },
                { text: "sent / skipped", value: "sent_at" },
            ];
        },
    },
    setup() {
        return { formatDateTimePragueTimeZone, statusLabelType };
    },
};
</script>

<style lang="scss" scoped>
.muted {
    font-size: 0.8rem;
    opacity: 0.7;
}
.data {
    font-size: 0.8rem;
    word-break: break-word;
    &-key {
        font-weight: 600;
    }
}
</style>
